module.exports = __webpack_public_path__ + "img/logo-144.aca8413c.png";